import { ArtCategory } from "../interfaces/arts.interface";

const artTypes = [
    {
        id: 1,
        title: 'Movie',
        description: 'Movie',
        type: ArtCategory.Movie,
        image: '/images/art-movie.png',
    },
    {
        id: 2,
        title: 'Book',
        description: 'Book',
        type: ArtCategory.Book,
        image: '/images/art-book.png',
    },
    {
        id: 3,
        title: 'Music',
        description: 'Music',
        type: ArtCategory.Music,
        image: '/images/art-music.png',
    },
    {
        id: 4,
        title: 'Art & Design',
        description: 'Art & Design',
        type: ArtCategory.Art,
        image: '/images/art-art-design.png',
    },
    {
        id: 5,
        title: 'Game',
        description: 'Game',
        type: ArtCategory.Game,
        image: '/images/art-game.png',
    },
    {
        id: 6,
        title: 'Performing art',
        description: 'Performing art',
        type: ArtCategory.PerformingArt,
        image: '/images/art-performing-art.png',
    }
]

export default artTypes;